<template>
  <div>
    <b-row>
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          @click="checkTotal()"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /><span style="color: #00FF80;"> วิเคราะห์: </span>{{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="text-sm-right"
      >
        <b-button
          v-if="itvdesk"
          v-b-modal="'modalLive'"
          class="mr-1"
          size="sm"
          title="กดเพื่อดูเพิ่มเติม"
          variant="outline-danger"
          @click="$refs.RTSP.streamLive(live)"
        ><b-img
          src="@/assets/images/icons/giphy.gif"
          style="height: 16px; width: 20px;"
        /> <span style="color:#fff;"> Live</span>
        </b-button>

        <a
          v-if="type === '0'"
          :href="anydesk"
        >
          <b-button
            size="sm"
            variant="outline-danger"
          ><b-img
            src="@/assets/images/logo/anydesk.png"
            style="height: 16px; width: 16px;"
          /> <span style="color:#fff;"> {{ anydesk1 }}</span></b-button>
        </a>
        <b-button
          v-if="type !== '0'"
          v-b-modal="'modalAnydesk'"
          class="mr-1"
          size="sm"
          title="กดเพื่อดูเพิ่มเติม"
          variant="outline-danger"
        ><b-img
          src="@/assets/images/logo/anydesk.png"
          style="height: 16px; width: 16px;"
        /> <span style="color:#fff;"> Anydesk</span>
        </b-button>

      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="8"
        md="8"
      >
        <div>
          <!-- Map🚀 -->
          <b-card style="font-size:18px; background-color:rgba(0, 0, 0, 0); width: 100%; color:#ffffff; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
              style="width: 100%; height: 755px;"
              @update:zoom="zoomUpdated"
            >
              <l-tile-layer :url="url" />
              <l-marker
                v-for="(marker, index) in markers"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.Latitude, marker.Longitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="stream1(marker.RTSP_URL, marker.Camera_Desc)"
              >
                <l-icon
                  :icon-size="[38, 50]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/markeranalytic120/analytic120.svg')"
                />
                <l-popup
                  ref="popup"
                >
                  <div>
                    <span style="color:white; font-size:14px;">
                      ตำแหน่ง:{{ marker.Camera_Desc }}
                    </span>
                    <video
                      id="video"
                      style="width:250px; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </l-popup>
              </l-marker>
            </l-map>
          </b-card>
        </div>
      </b-col>

      <b-col
        lg="4"
        md="4"
        class="mb-2"
      >
        <b-row>
          <b-col v-if="namecam">
            <b-col
              v-for="(link, index) in rtsp.slice(0,1)"
              :key="index"
              class="mb-1"
              align-self="baseline"
              lg="12"
              md="12"
            >
              <svg
                width="105%"
                height="100%"
                viewBox="0 0 1046 691"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-left: -15px;"
              >
                <path
                  d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                  stroke="#00B058"
                />
                <path
                  d="M66 689H29.9165L2 649.571V605"
                  stroke="#00B058"
                  stroke-width="4"
                />
                <path
                  d="M974 2H1013.47L1044 38.6122V80"
                  stroke="#00B058"
                  stroke-width="4"
                />
                />
                <foreignObject
                  width="100%"
                  height="100%"
                  x="25"
                  y="7"
                >
                  <div>
                    <b-img
                      height="55"
                      src="@/assets/images/icons/cctv.svg"
                    />
                  </div>
                </foreignObject>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="-680"
                  y="-15"
                >
                  <div>
                    <span class="text1">กล้องวงจรปิด</span>
                  </div>
                </foreignObject>
                <foreignObject
                  x="0"
                  y="627"
                  width="100%"
                  height="90%"
                >
                  <div>
                    <h1 class="text2 mt-1">ตำแหน่ง: {{ namecam }}</h1>
                  </div>
                </foreignObject>
                <foreignObject
                  x="25"
                  y="70"
                  width="100%"
                  height="90%"
                >
                  <div>
                    <video
                      :id="'video' + index"
                      style="width:95%; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </foreignObject>
              </svg>
            </b-col>
          </b-col>

          <b-col
            v-else
            class="mb-1"
            align-self="baseline"
            lg="12"
            md="12"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1046 691"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                stroke="#00B058"
              />
              <path
                d="M66 689H29.9165L2 649.571V605"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M974 2H1013.47L1044 38.6122V80"
                stroke="#00B058"
                stroke-width="4"
              />
              />
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="7"
              >
                <div>
                  <b-img
                    height="55"
                    src="@/assets/images/icons/cctv.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="-680"
                y="-15"
              >
                <div>
                  <span class="text1">กล้องวงจรปิด</span>
                </div>
              </foreignObject>
              <foreignObject
                x="25"
                y="70"
                width="100%"
                height="90%"
              >
                <div
                  style="margin-right: 70px;"
                >
                  <center>
                    <img
                      height="620px"
                      src="@/assets/images/icons/markeranalytic120/Nocctv.svg"
                    >
                  </center>
                </div>
              </foreignObject>
            </svg>
          </b-col>

          <b-col
            cols="12"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1046 691"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M964.03 688.647H964.031H1045.5V644.686V600.225V351.058V101.89V44.9474L1011.78 0.5H0.5V44.4611V88.9222V596.52V646.01L34.2183 690.5L964.03 688.647Z"
                stroke="#00B058"
              />
              <path
                d="M66 689H29.9165L2 649.571V605"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M974 2H1013.47L1044 38.6122V80"
                stroke="#00B058"
                stroke-width="4"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="5"
              >
                <div>
                  <b-img
                    height="60"
                    src="@/assets/images/icons/markeranalytic120/iconimage.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                x="25"
                y="72"
                width="100%"
                height="90%"
              >
                <div>
                  <div v-if="img">
                    <!-- <span class="text1">ภาพการวิเคราะห์จราจรล่าสุด</span> -->
                    <b-img
                      :src="img"
                      style="width:95%; height:auto; flex-direction: row;"
                    />
                  </div>
                  <div
                    v-else
                    style="margin-right: 70px;"
                  >
                    <center>
                      <img
                        height="620px"
                        src="@/assets/images/icons/markeranalytic120/Noimage.svg"
                      >
                    </center>
                  </div>
                </div>
              </foreignObject>
              <foreignObject
                v-if="camid"
                x="-230"
                y="-10"
                width="100%"
                height="90%"
              >
                <div>
                  <h1 class="text1">ภาพการวิเคราะห์จราจรล่าสุด (กล้อง {{ camid }})</h1>
                </div>
              </foreignObject>
              <foreignObject
                v-else
                x="-400"
                y="-10"
                width="100%"
                height="90%"
              >
                <div>
                  <h1 class="text1">ภาพการวิเคราะห์จราจรล่าสุด</h1>
                </div>
              </foreignObject>
              <foreignObject
                v-if="camdesc"
                x="0"
                y="626"
                width="100%"
                height="90%"
              >
                <div>
                  <!-- <h1 class="text2 mt-1">จุดติดตั้ง: {{ camdesc }}</h1> -->
                  <h1 class="text2 mt-1">{{ date }} ({{ detection }})</h1>
                </div>
              </foreignObject>
              <foreignObject
                v-else
                x="0"
                y="626"
                width="100%"
                height="90%"
              >
                <div />
              </foreignObject>
            </svg>
          </b-col>
        </b-row>
      </b-col>
      <!-- <b-img :src="items[0].FilePath" /> -->
    </b-row>
    <modalLive
      ref="RTSP"
    />
    <modal-Anydesk />
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BImg, BLink, BButton, BCard,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import modalLive from './modalLive.vue'
import modalAnydesk from '../detailCarstop/modalAnydesk.vue'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BImg,
    BLink,
    BButton,
    BCard,
    modalLive,
    modalAnydesk,
  },

  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 13,
      center: [0, 0],
      waydetail: '',
      markers: [],
      detail: '',
      deptid: '',
      img: '',
      rtsp: [],
      namecam: '',
      lat: '',
      lng: '',
      type_name: '',
      camid: '',
      camdesc: '',
      detection: '',
      date: '',
      anydesk: '',
      anydesk1: '',
      live: '',
      itvdesk: '',
      type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.type = this.$route.query.type
    this.for()
    this.getMarkerAnalytic()
    this.getLastImg()
    this.getCamAnalytic()
    this.getWayAnalytic()
    this.getEventImgAnalytic()
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())

    this.interval = setInterval(() => {
      this.for()
      this.getCamAnalytic()
      this.getEventImgAnalytic()
    }, 300000)
  },
  methods: {
    checkTotal() {
      axios
        .post('/checkAITotal', { DeptID: this.deptid })
        .then(response => {
          if (response.data[0].count_deptid > 1) {
            this.$router.push({ path: '/analytic-sub', query: { DeptID: this.deptid } })
          } else {
            this.$router.push({ path: '/analytic120-total' })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getWayAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getWayAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.zoom = response.data[0].mapzoom
            this.deptid = response.data[0].deptid
            this.center = []
            this.center.push(response.data[0].latitude)
            this.center.push(response.data[0].longitude)
            this.waydetail = response.data[0].detail
            this.type_name = response.data[0].type_name
            this.live = response.data[0].desktop_screen
            this.anydesk = `anydesk:${1798885008}`
            this.anydesk1 = response.data[0].anydesk
            this.itvdesk = response.data[0].itvdesk_license_req
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getWayAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.zoom = response.data[0].mapzoom
            this.deptid = response.data[0].deptid
            this.center = []
            this.center.push(response.data[0].latitude)
            this.center.push(response.data[0].longitude)
            this.waydetail = response.data[0].detail
            this.type_name = response.data[0].type_name
            this.live = response.data[0].desktop_screen
            this.anydesk = `anydesk:${response.data[0].anydesk}`
            this.anydesk1 = response.data[0].anydesk
            this.itvdesk = response.data[0].itvdesk_license_req
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    zoomUpdated(value) {
      setTimeout(() => axios
        .post('/updateMapZoom', {
          mapzoom: value, wid: this.$route.query.wid, type_name: this.type_name,
        })
        .then(response => {
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        }), 1000)
    },
    getCamAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCamAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCamAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.rtsp = response.data
            this.namecam = response.data[0].Camera_Desc
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getMarkerAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getMarkerAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.markers = response.data
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getMarkerAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.markers = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getLastImg() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getLastImgAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.img = response.data[0].FilePath
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getLastImgAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.img = response.data[0].FilePath
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    stream1(value) {
      setTimeout(() => {
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },
    for() {
      setTimeout(() => this.rtsp.forEach((value, i) => {
        this.stream(value.RTSP_URL, i)
      }), 500)
    },
    stream(value, i) {
      console.log(value)
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#video${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },

    getEventImgAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getEventImgAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.camid = response.data[0].CAMID
            this.camdesc = response.data[0].Camera_Desc
            this.detection = response.data[0].Detection_Type
            this.date = response.data[0].DATE_TIME
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getEventImgAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.camid = response.data[0].CAMID
            this.camdesc = response.data[0].Camera_Desc
            this.detection = response.data[0].Detection_Type
            this.date = response.data[0].DATE_TIME
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  // .vue2leaflet-map {
  //     &.leaflet-container{
  //     position: absolute;
  //     width: 100%;
  //     height: 638px;
  //     }
  // }
.text1 {
font-size: 44px;
color: #ffffff;
// font-weight: bold;
}
.text2 {
font-size: 34px;
color: #ffffff;
text-align: center;
// font-weight: bold;
}

.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(2,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}

</style>
